import { createAction, props } from '@ngrx/store';
import { ProductSearchPage } from '@boels/models';

export const LOAD_PRODUCT_SEARCH_PAGE =
  '[Product Search] Load Product Search Page';
export const LOAD_PRODUCT_SEARCH_PAGE_SUCCESS =
  '[Product Search] Load Product Search Page Success';
export const LOAD_PRODUCT_SEARCH_PAGE_FAIL =
  '[Product Search] Load Product Search Page Fail';
export const GET_PRODUCT_SEARCH_PAGE =
  '[Product Search] Get Product Search Page';

export const loadProductSearchPage = createAction(
  LOAD_PRODUCT_SEARCH_PAGE,
  props<{
    categoryId: string;
    currentPage?: number;
    sortCode?: string;
    culture: string;
    query?: string;
  }>(),
);

export const getProductSearchPage = createAction(
  GET_PRODUCT_SEARCH_PAGE,
  props<{
    categoryId: string;
    currentPage?: number;
    sortCode?: string;
    query?: string;
  }>(),
);

export const loadProductSearchPageSuccess = createAction(
  LOAD_PRODUCT_SEARCH_PAGE_SUCCESS,
  props<{
    productSearchPage: ProductSearchPage;
    sortCode: string;
    culture: string;
    query: string;
  }>(),
);

export const loadProductSearchPageFail = createAction(
  LOAD_PRODUCT_SEARCH_PAGE_FAIL,
  props<{ errorMessage: string }>(),
);
